import React from "react";
import LineExplanation from "./LineExplanation";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Badge,
    UncontrolledCollapse
  } from "reactstrap";
  
export default class PoemLine extends React.Component {
    constructor(){
        super();
        this.replaceTags = this.replaceTags.bind(this);
    }
    replaceTags(lineText, tags) {
      if(tags !== undefined)  {
      tags.forEach(tag => tag.namesList.forEach(tagName => {
            // console.log(tagName);
            lineText = lineText.replace(tagName,"<a style='cursor:pointer;background-color:#"+tag.categoriesList[0].colour+"' onclick='window.poemPage.showTag("+tag.tagId+")' onMouseEnter='window.showTooltip(\""+tagName.replace(/"/gi,"&quot;")+" : "+tag.description.replace(/"/gi,"&quot;")+"\", event.clientX+20, event.clientY)' onmouseout='window.hideTooltip()'>"+tagName+"</a>");
        }));
      }

        if(this.props.matchingSearchWords !== undefined) {
          this.props.matchingSearchWords.forEach(word => {
            lineText = lineText.replace(word,"<span style='background-color:yellow'>"+word+"</span>");
          });
        }
  
        return lineText;
    }
    render() {
    const line = this.props.line;
    return (
      <div style={{textAlign:'center'}}>
        <div style={{textAlign:'center'}}>
          <a
            id={"line" + line.lineId}
            style={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
          >
            [الشروح {line.explanationsCount}]
          </a>&nbsp; {line.sequence}&nbsp;&nbsp;
          <span style={{width:'220px',display:'inline-block',textAlign:'right'}} dangerouslySetInnerHTML={{__html: this.replaceTags(line.line1, line.tags)}}/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span style={{width:'220px',display:'inline-block',textAlign:'right'}} dangerouslySetInnerHTML={{__html: this.replaceTags(line.line2, line.tags)}}/>
        </div>
        <UncontrolledCollapse toggler={"#line" + line.lineId}>
          <LineExplanation lineId={line.lineId} />
        </UncontrolledCollapse>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/PoemLine.js